import { useCanEditNewsEventArticle } from "features/NewsEvents/hooks/useCanEditNewsEventArticle";
import { parseAsBoolean, useQueryState } from "nuqs";
import { SingleEventPageEdit } from "./SingleEventPageEdit";
import { SingleEventPageView } from "./SingleEventPageView";

export function SingleEventPage() {
  const [editMode] = useQueryState("edit", parseAsBoolean.withDefault(false));
  const canEdit = useCanEditNewsEventArticle();
  const showEdit = canEdit && editMode;
  return showEdit ? (
    <SingleEventPageEdit />
  ) : (
    <SingleEventPageView canEdit={canEdit} />
  );
}
